class LomondeMediaDescription extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const button = this.querySelector('button');
    const panel = this.querySelector('.lm-media-description__text');
    const host = this.closest('.product-media-container');
    if (!button || !panel || !host) return;
    this.setOpen = (open) => {
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.querySelector('span').textContent = open ? '−' : '+';
    };
    this.addEventListener('click', (event) => event.stopPropagation(), options);
    button.addEventListener('click', () => this.setOpen(panel.hidden), options);
    host.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') this.setOpen(true);
    }, options);
    host.addEventListener('pointerleave', () => {
      if (!this.contains(document.activeElement)) this.setOpen(false);
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { this.setOpen(false); event.stopPropagation(); button.focus(); }
    }, options);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.setOpen(false);
    }, options);
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('lm-media-description')) customElements.define('lm-media-description', LomondeMediaDescription);
